import template from './sw-cms-block-custom-form.html.twig';

export default {
    template,
}
